import * as ContactsFeature from './lib/+state/contacts.reducer';

import * as ContactsSelectors from './lib/+state/contacts.selectors';

export { ContactsFeature, ContactsSelectors };

export * from './lib/shared-data-access-contacts.module';

export { ContactsService } from './lib/services/contacts.service';
